import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyService } from "./Company.service";
import { finalize, skip, takeUntil } from "rxjs/operators";



@Injectable()
export class CompanyInterceptor implements HttpInterceptor {

  // APIs that should NOT receive company_id
  private excludedUrls = [
    '/login',
    '/auth',
    '/public',
    'googleapis.com',
    'youtube.com'
  ];

  // Flag to control gc_id behavior for Master routes:
  // true  => Force gc_id=0 for all master requests (Current Temporary Mode)
  // false => Use active company ID from Company.service (Future Mode)
  private forceMasterGcIdZero = true;

  constructor(
    private companyService: CompanyService,
    //private loader: LoaderService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    // Company context is rehydrated once at app startup by AppInitService.
    // Do NOT re-read from localStorage here — it causes cross-tab contamination
    // when multiple tabs have different companies selected.

    // skip excluded APIs
    if (this.excludedUrls.some(url => req.url.includes(url))) {
      return next.handle(req);
    }

    const isMasterRoute = window.location.pathname.includes('/master/');
    let modifiedReq = req;

    // Handle Master routes centrally
    if (isMasterRoute) {
      if (this.forceMasterGcIdZero) {
        // Current Temporary Mode: Force gc_id=0 for all master requests unless explicitly provided
        if (!req.params.has('gc_id')) {
          modifiedReq = req.clone({
            params: req.params.set('gc_id', '0')
          });
        }
      } else {
        // Future Mode: Acquire active company ID from Company.service
        const companyId = this.companyService.getCurrentCompany();
        if (companyId && !req.params.has('gc_id')) {
          modifiedReq = req.clone({
            params: req.params.set('gc_id', companyId.toString())
          });
        }
      }

      return next.handle(modifiedReq).pipe(
        finalize(() => {})
      );
    }

    const companyId = this.companyService.getCurrentCompany();

    if (req.method == 'GET' && req.url.includes('project/get-project-list/') && companyId == 0) {
      modifiedReq = req.clone({
        params: req.params.set('gc_id', '')
      });
    } else
      if (req.method == 'GET' && req.url.includes('project/get-project/') && window.location.pathname.includes('project/list')) {
        modifiedReq = req.clone({
          params: req.params.set('gc_id', '')
        });
      }
      else
        if (
          //(req.method == 'GET' && req.url.includes('project/get-project-extender/')) ||
          (req.url.includes('switch-user/')) ||
          (req.url.includes('/requisition_for/get')) ||
          (req.url.includes('/supply_status/get')) ||
          (req.url.includes('/requisition_status/get')) ||
          (req.url.includes('/project_status/get')) ||

          (req.url.includes('/requisition/delete-requisition-docs/')) ||
          ((companyId == 0 || companyId == null) && !window.location.pathname.includes('/master/')) ||
          (companyId == 0 && (req.url.includes('/dashboard/get-count/')))
        ) {
          // No gc_id attached for these requests
        }
        else if (req.method == 'GET' && (req.url.includes('general-contractor/get-gc-list'))) {
          if (window.location.pathname.includes('general-contractor/list')) {
            // Restrict adding the company id parameter on the general contractor list page
          } else {
            modifiedReq = req.clone({
              params: req.params.set('id', companyId ? companyId.toString() : '')
            });
          }
        }
        else if (req.method == 'GET' && (req.url.includes('general-contractor/get-gc-user/'))) {
          modifiedReq = req.clone({
            params: req.params.set('gc_id', companyId ? companyId.toString() : '')
          });
        }
        else if (req.method == 'GET' && (req.url.includes('general-contractor/get-gc/'))) {
          modifiedReq = req.clone({
            params: req.params.set('id', companyId ? companyId.toString() : '')
          });
        }
        else if (companyId) {

          // // 🔁 OPTION A: attach as HEADER (recommended)
          // modifiedReq = req.clone({
          //   setHeaders: {
          //     company_id: companyId.toString()
          //   }
          // });

          // 🔁 OPTION B: attach as QUERY PARAM (if backend expects)

          modifiedReq = req.clone({
            params: req.params.set('gc_id', companyId.toString())
          });

        } else {
          modifiedReq = req.clone({
            params: req.params.set('gc_id', '0')
          });
        }



    // show loader
    //this.loader.show();

    return next.handle(modifiedReq).pipe(
      finalize(() => {
        // this.loader.hide(); // enable later if needed
      })
    );

  }

  set_gc_id_header(gc_id: any) {

    if (gc_id) {

      this.companyService.setHeaderCompany(gc_id);
      localStorage.setItem('header_gc_id', gc_id.toString());
    }
  }
}
